import schedulesViewStateStore from "../store/store";
import { mutatorAction } from "satcheljs";
import { SaveStates } from "sh-application/components/common/SaveStatusCommandBarItem";

export default mutatorAction('SET_SCHEDULE_SAVE_STATE', function setScheduleSaveState(
    saveState: SaveStates
) {
    schedulesViewStateStore().saveState = saveState;
});
